

























































































































import { Account } from '@accounting/interfaces/account';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import InvoiceSyncSettingForm from '../invoice-sync-setting-form/invoice-sync-setting-form.vue';

@Component({
  name: 'bpc-export-modal',
  components: {
    'bpc-invoice-sync-setting-form': InvoiceSyncSettingForm,
  },
})
export default class AccountSyncModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'account-sync-confirmation-modal' }) readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selection: number[];
  @Prop({ type: String, default: '' }) readonly syncService: string;

  // DATA
  public showInvoiceSyncSettingForm = false;
  public loading = false;
  public showReportData = false;
  public reportData: { synced: Account[]; notSynced: Account[] } = { synced: [], notSynced: [] };
  public syncFinished: boolean = false;

  public errorReportPerPage: number = 5;
  public errorReportCurrentPage: number = 1;
  public successReportPerPage: number = 5;
  public successReportCurrentPage: number = 1;
  public uxSessionCode = 'account-sync-modal-session-code';

  // LIFECYCLE
  mounted() {
    this.showReportData = false;
    this.showInvoiceSyncSettingForm = false;
    this.syncFinished = false;

    this.uxSessionCode = `account-sync-modal-${Date.now()}`;
    this.listenToWebsocketAccountSyncChannel(this.uxSessionCode);
    this.reportData = { synced: [], notSynced: [] };
    if (this.showModal) {
      this.openModal();
    }
  }

  destroyed() {
    this.$bpcEcho.leaveInvoiceSyncChannel(this.uxSessionCode);
  }

  // COMPUTED
  get modalConfig() {
    if (this.syncService === 'exact') {
      return {
        id: 'modal-account-sync',
        title: this.$t('global.modals.account-sync.title') as string,
        body: this.$t('global.modals.account-sync.body') as string,
        cancelText: this.$t('global.buttons.cancel') as string,
        acceptText: this.$t('global.buttons.confirm') as string,
        acceptButtonVariant: 'info',
      };
    } else {
      return {
        id: 'modal-account-sync',
        title: this.$t('global.modals.account-sync-odoo.title') as string,
        body: this.$t('global.modals.account-sync-odoo.body') as string,
        cancelText: this.$t('global.buttons.cancel') as string,
        acceptText: this.$t('global.buttons.confirm') as string,
        acceptButtonVariant: 'info',
      };
    }
  }

  get notSynced() {
    return this.reportData?.notSynced;
  }
  get synced() {
    return this.reportData?.synced;
  }

  get errorReportRows() {
    return this.notSynced.length;
  }
  get errorReportCurrentList() {
    const start = (this.errorReportCurrentPage - 1) * this.errorReportPerPage;
    const end = start + this.errorReportPerPage;
    return this.notSynced.slice(start, end);
  }
  get notFound() {
    if (this.syncService === 'odoo') {
      return 'global.accounting.accounts.sync_report_errors.not_found_odoo';
    }
    return 'global.accounting.accounts.sync_report_errors.not_found';
  }

  get successReportRows() {
    return this.synced.length;
  }
  get successReportCurrentList() {
    const start = (this.successReportCurrentPage - 1) * this.successReportPerPage;
    const end = start + this.successReportPerPage;
    return this.synced.slice(start, end);
  }

  get apiPath() {
    switch (this.syncService) {
      case 'odoo':
        return `${this.$bpcApiRouteHelper.getEntityPath('accounts')}/sync-with-odoo`;
      case 'exact':
        return `${this.$bpcApiRouteHelper.getEntityPath('accounts')}/sync-with-exact`;
      default:
        return `${this.$bpcApiRouteHelper.getEntityPath('accounts')}/sync`; // Does not exist, will fail
    }
  }

  // METHODS
  onCloseModal() {
    this.$emit('close-modal');
  }

  async onConfirmSyncAccounts() {
    this.syncFinished = false;
    this.loading = true;
    const path = this.apiPath;

    try {
      const res = await this.$bpcApi.post(path, { ids: this.selection }).toPromise();
      this.loading = false;
      this.reportData = res.data;
      this.showReportData = true;
      this.syncFinished = true;
      this.$emit('synced', this.selection);
    } catch (error) {
      this.manageAccountSyncError(error);
    }
  }

  manageAccountSyncError(error) {
    this.loading = false;
    this.showReportData = false;

    const exceptionType = error?.response?.data?.exception;
    const message = error?.response?.data?.message;
    switch (exceptionType) {
      case 'BPC\\AccountingIntegrations\\Exceptions\\TenantNotReadyToSyncInvoicesException':
        this.$bpcMessage.showErrorMessage({ text: message });
        this.showInvoiceSyncSettingForm = true;
        break;

      default:
        this.$bpcMessage.showErrorMessage({
          text: 'global.invoices_to_sync_item.error',
        });
        break;
    }
  }

  listenToWebsocketAccountSyncChannel(sessionCode) {
    this.$bpcEcho
      .getInvoiceSyncChannel(sessionCode)
      .listen('.BPC\\AccountingIntegrations\\Events\\ExactConfigSaved', data => {
        console.log('ExactConfigSaved', data);
        this.$bpcMessage.showInfoMessage({
          text: 'global.invoice_sync_items.exact_config_saved',
        });
        this.showInvoiceSyncSettingForm = false;
      });
  }

  openModal() {
    this.showReportData = false;
    this.showInvoiceSyncSettingForm = false;
    this.syncFinished = false;
    this.$bvModal.show(this.modalId);
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
